import { FC } from 'react';
import { SidebarPagesParams } from '../config';
import { NavLink } from 'react-router';
import { useRoute } from 'src/router/hooks/useRoute';
import { useTranslation } from 'react-i18next';
import { useDrawer } from 'src/hooks/useDrawer';

interface PagesItemProps {
  option: SidebarPagesParams;
}

export const PagesItem: FC<PagesItemProps> = ({ option }) => {
  const { t } = useTranslation();
  const { ROUTE } = useRoute();
  const { closeDrawer } = useDrawer();

  return (
    <NavLink
      to={ROUTE.CUSTOM.get(option.path as string)}
      className="flex justify-start items-center gap-2 w-full group"
      onClick={closeDrawer}
      end>
      <p className="text-sgc_page_item_color text-base font-medium px-2 group-hover:text-sgc_page_item_color_hovered transition-colors duration-200">
        {t(option.title)}
      </p>
      {option?.highlighted && <div className="w-2 h-2 rounded-full bg-sgc_page_item_dot_bg" />}
      {option?.new && (
        <div className="bg-[linear-gradient(180deg,#A8FF28_0%,#2BB83E_100%)] py-0.5 px-1 rounded uppercase text-text_color_bage font-bold text-xs">
          {t('categoriesItem.new')}
        </div>
      )}
    </NavLink>
  );
};
